import { isExpired } from "react-jwt";
import UserProfile from "./userProfile";
const userProfile = new UserProfile();

export default class Auth {

  setSession(authResult) {
    localStorage.setItem('token', authResult.token);
    
    setTimeout(() => {
      userProfile.setUserProfile(authResult.token).then(res => {
        const isFirstLogin = res.status === 0;
        if (isFirstLogin) {
          window.location.replace('/login/change-password');
        } else {
          window.location.replace('/');
        }
      }).catch(err => console.log(err));
    }, 1000);
  }

  clearLocalStorage() {
    // localStorage.removeItem('token');
    // localStorage.removeItem('user-profile');
    // localStorage.removeItem('username');
    // localStorage.removeItem('menu-access');
    localStorage.clear();
  }

  logout() {
    // Clear access token and ID token from local storage
    this.clearLocalStorage();
    window.location.replace('/login');
  }
  
  isAuthenticated() {
    const token = localStorage.getItem('token');
    const isTokenExpired = isExpired(token);
    
    if(isTokenExpired) {
      this.clearLocalStorage();
      return false;
    }
    return true;
  }
}
